import type Plyr from 'plyr';
import { CustomElement } from '@/utils';

export default class Component extends CustomElement {
  static component = 'b-component';

  init() {
    const site = this.getAttribute('site') === 'en' ? '' : `/${this.getAttribute('site')}`;
    fetch(`${site}/component/${this.getAttribute('component')}`)
      .then(response => response?.text() || Promise.resolve(''))
      .then(data => {
        this.innerHTML = data;
      })
      .catch();
  }
}
